import { Menu } from '@mantine/core';
import { Icon, IconButton } from '@repo/foundations';

interface BiDashboardActionsProps {
	onRefresh: () => void;
	onDelete: () => void;
	handleCopyToPng: () => void;
	handleDownloadPng: () => void;
	hasManagePermission?: boolean;
}

export function BiDashboardActions({
	onRefresh,
	onDelete,
	handleCopyToPng,
	handleDownloadPng,
	hasManagePermission = true,
}: BiDashboardActionsProps) {
	return (
		<Menu>
			<Menu.Target>
				<IconButton iconName="dots" variant="tertiary" tooltip="More actions" />
			</Menu.Target>
			<Menu.Dropdown>
				{hasManagePermission && (
					<Menu.Item icon={<Icon name="refresh" />} onClick={onRefresh}>
						Refresh data
					</Menu.Item>
				)}
				<Menu.Item icon={<Icon name="copy" />} onClick={handleCopyToPng}>
					Copy as PNG
				</Menu.Item>
				<Menu.Item icon={<Icon name="download" />} onClick={handleDownloadPng}>
					Download PNG
				</Menu.Item>
				{hasManagePermission && (
					<>
						<Menu.Divider />
						<Menu.Item icon={<Icon name="trash" />} onClick={onDelete}>
							Delete...
						</Menu.Item>
					</>
				)}
			</Menu.Dropdown>
		</Menu>
	);
}
